import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CadastroBem } from '../models/cadastro-bem';

import { catchError, debounceTime, map } from 'rxjs/operators'; 
import { environment as env } from 'src/environments/environment';
import { Relatorio } from '../models/relatorio';
import { SolicitacaoBens } from '../models/solicitacao-bens';
@Injectable({
  providedIn: 'root'
})
export class CadastroBemService {

  private readonly PATH: string = '/Bens';
  private readonly PATH_MAT: string = '/Bens/Matricula/';
  private readonly PATH_CADASTRAR = '/Bens';
  private readonly PATH_ALT = '/Bens';
  private readonly PATH_REMOV = '/Bens';
  private readonly PATH_GET_ALL = '/Bens/GetAll';
  private readonly PATH_RELATORIO = '/Bens/Relatorio';
  private readonly PATH_MEUSBENS = '/Bens/MeusBens';
  private readonly PATH_PLANILHA = '/Bens/Planilha';
  private readonly PATH_SOLICITAR = '/Bens/Solicitacao';

  constructor(private http:HttpClient) { }
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  public errorHandl(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }

  insert(cadastroBem:CadastroBem):Observable<any>{
    return this.http.post(
      env.baseurl + this.PATH_CADASTRAR,cadastroBem,{responseType:'text'})
      .pipe(catchError(this.errorHandl));
      
    } 

  listarPage(page:any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_GET_ALL,page) 
    .pipe(catchError(this.errorHandl));
  }
  listarBensAll():Observable<any>{
    return this.http.get(env.baseurl+this.PATH);
  }
  listarBensApenas():Observable<any>{
    return this.http.get(env.baseurl+ '/Bens/apenasBens');
  }
  listarBensById(cD_BPM_BEM_PATRIMONIAL:number):Observable<any>{
    return this.http.get(env.baseurl + this.PATH +'/'+ cD_BPM_BEM_PATRIMONIAL);
  }
  listarBensByEtiqueta(dS_BPM_ETIQUETA_BEM:any):Observable<any>{
    return this.http.get(env.baseurl + this.PATH +'/Etiqueta/'+ dS_BPM_ETIQUETA_BEM);
  }
  listarMatById(CD_CDU_MATRICULA:number):Observable<any>{
    return this.http.get(env.baseurl + this.PATH_MAT+ CD_CDU_MATRICULA);
  }
  update(cD_BPM_BEM_PATRIMONIAL:number,cadastroBem:CadastroBem):Observable<any>{
    return this.http.put(
      env.baseurl + this.PATH_ALT 
      + '/' + cD_BPM_BEM_PATRIMONIAL,cadastroBem,{responseType:'text'})
      .pipe(catchError(this.errorHandl));
  }
  delete(cD_BPM_BEM_PATRIMONIAL:number):Observable<any>{
    return this.http.delete(env.baseurl + this.PATH_REMOV +'/'+ cD_BPM_BEM_PATRIMONIAL,{responseType:'text'})
  }

  getRelatorioBens(relatorio:Relatorio):Observable<any>{
    return this.http.post(env.baseurl + this.PATH_RELATORIO,relatorio, {responseType:'blob'})
  }

  getMeusBens(cD_CDU_MATRICULA:number,page:any):Observable<any>{
    return this.http.post(env.baseurl + this.PATH_MEUSBENS +'/'+cD_CDU_MATRICULA,page) 
    .pipe(catchError(this.errorHandl));
  }

  uploadPlanilha(file:any):Observable<any> {
    return this.http.post(
      env.baseurl + this.PATH_PLANILHA,file,
      {
        observe: 'events',
        reportProgress:true
      })
  }
  insertSolicitacao(solicitacao:SolicitacaoBens):Observable<any>{
    return this.http.post(
      env.baseurl + this.PATH_SOLICITAR,solicitacao,{responseType:'text'})
      .pipe(catchError(this.errorHandl));
      
    } 
}
